// extracted by mini-css-extract-plugin
module.exports = {"session-dialog":"existing-session-dialog_session-dialog__1Ckhf","container":"existing-session-dialog_container__2R3eP"};